<template>
  <b-row class="justify-content-center">
    <b-card bg-variant="light" class="col-6">
      <b-form @submit="handleSubmit">
        <b-form-group
          :label="$t('login.username.label')"
          label-for="username"
          :state="!submitted || !!username"
          invalid-feedback="Username is required"
        >
          <b-form-input
            type="text"
            v-model="username"
            id="username"
            autocomplete="username"
          ></b-form-input>
        </b-form-group>
        <b-form-group
          :label="$t('login.password.label')"
          label-for="password"
          :state="!submitted || !!password"
          invalid-feedback="Password is required"
        >
          <b-form-input
            type="password"
            v-model="password"
            id="password"
            autocomplete="current-password"
          ></b-form-input>
        </b-form-group>
        <b-form-group>
          <b-button type="submit" variant="primary" :disabled="isLoading">Login</b-button>
          <img v-show="isLoading" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
        </b-form-group>
      </b-form>
    </b-card>
  </b-row>
</template>

<script>
  export default {
    data () {
      return {
        username: '',
        password: '',
        submitted: false
      }
    },
    computed: {
      isLoading () {
        return this.$store.getters['isLoading'];
      }
    },
    created () {
      // reset login status
      this.$store.dispatch('authentication/logout');
    },
    methods: {
      handleSubmit (evt) {
        evt.preventDefault();
        this.submitted = true;
        const { username, password } = this;
        const { dispatch } = this.$store;
        if (username && password) {
          dispatch('authentication/login', { username, password });
        }
      }
    }
  };
</script>
